module.exports = __webpack_public_path__ + "assets/img/6_1.7557c213.png";